import { Terminal } from '../models/terminal.model';

export const COMMON_TERMINALS: Terminal[] = [
  {
    name: 'Barcelona El Prat - T1',
    commonTerminalId: 1,
    placeId: 1,
    idLot: 5,
    terminals: [51, 55, 82]
  },
  {
    name: 'Barcelona El Prat - T2',
    commonTerminalId: 2,
    placeId: 1,
    idLot: 5,
    terminals: [52, 56, 83]
  },
  {
    name: 'Sants',
    commonTerminalId: 3,
    placeId: 2,
    idLot: 2,
    terminals: [21]
  },
  {
    name: 'Puerto WTC',
    commonTerminalId: 4,
    placeId: 5,
    idLot: null,
    terminals: [22]
  },
  {
    name: 'Atocha',
    commonTerminalId: 5,
    placeId: 3,
    idLot: 3,
    terminals: [31]
  },
  {
    name: 'Barajas T1',
    commonTerminalId: 6,
    placeId: 4,
    idLot: 6,
    terminals: [74]
  },
  {
    name: 'Barajas T2, T3',
    commonTerminalId: 7,
    placeId: 4,
    idLot: 6,
    terminals: [75]
  },
  {
    name: 'Barajas T4',
    commonTerminalId: 8,
    placeId: 4,
    idLot: 6,
    terminals: [76]
  },
];

export const URBAN_PARKINS: Terminal[] = [
  {
    name: 'Parking David',
    commonTerminalId: 80,
    placeId: null,
    idProduct: 13,
    idTerminal: 80,
  },
];

export function getPlaceIdfromCommonTerminalId(
  commonTerminalId: number
): number {
  if (!commonTerminalId) return null;
  const c = COMMON_TERMINALS.find(
    (t: Terminal) => t.commonTerminalId === Number(commonTerminalId)
  );
  return c ? c.placeId : null;
}
